import { useState, useEffect } from "react"
import { useApp } from "context/useApp"
import { getProperty, updateProperty } from "actions/property-actions"
import Paginator from "components/paginator/paginator"
import { Link, useNavigate, useParams } from "react-router-dom"
import { formatDate } from "actions/global-actions"
import {
  propertyPaymentsTableHeaders,
  propertyPaymentsTableBody,
} from "./property-payments-list-data"
import TableComponent from "components/table/table"
import { alert } from "components/Alert"
import { stringToCurrency } from "components/StringToCurrency"

function PropertyPaymentsList() {
  const { id } = useParams()
  const [payments, setPayments] = useState([])
  const [loadData, setLoadData] = useState(true)
  const { user, setLoading } = useApp()
  const currentLink = "/inmuebles"
  const [currentData, setCurrentData] = useState({})

  const navigate = useNavigate()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getProperty(id, setLoading, user.token)
        let data = response.data
        if (data.code === "01") {
          alert("Error", data.message)
          return
        }

        //console.log(data[0]);
        let requests = data[0].requests || []
        //console.log('requests', requests);
        let payments = []
        requests.forEach((request, requestIndex) => {
          request.contracts.forEach((contract, contractIndex) => {
            contract.payments.forEach((payment, paymentIndex) => {
              let newPayment = {}
              newPayment.requestIndex = requestIndex
              newPayment.tenant = `${request.firstName} ${request.lastName} ${request.documentType} No ${request.document}`
              newPayment.contractIndex = contractIndex
              newPayment.date = formatDate(payment.createdAt, 4)
              newPayment.monthPaidText = formatDate(payment.monthPaid, 6)
              newPayment.monthPaid = new Date(payment.monthPaid)
              newPayment.valuePaidText = stringToCurrency(payment.valuePaid)
              newPayment.paymentIndex = paymentIndex
              newPayment.link = `${currentLink}/${id}/pagos/${payment._id}/editar`
              payments.push(newPayment)
            })
          })
        })

        payments.sort((a, b) => b.monthPaid - a.monthPaid)

        setPayments(payments)
        setCurrentData(data[0])
      } catch (error) {
        console.error(error)
      }
    }

    if (loadData) {
      setLoadData(false)
      setPayments([])
      setCurrentData({})
      fetchData()
    }
  }, [loadData, user.token, id])

  const handleOnClick = async (payment) => {
    if (
      window.confirm(
        `¿Realmente desea eliminar el pago con datos: Inquilino: ${payment.tenant}, Fecha ${payment.date}, ¡ESTA OPCIÓN NO SE PUEDE DESHACER!`,
      )
    ) {
      currentData.requests[payment.requestIndex].contracts[
        payment.contractIndex
      ].payments.splice(payment.paymentIndex, 1)
      const response = await updateProperty(currentData, setLoading, user.token)
      if (response.data.code === "01") {
        alert("Error", response.data.message)
        return
      }
      //console.log('data',data);
      alert("¡Éxito!", "Pago eliminado con éxito")
      setLoadData(true)
    }
  }

  const updateFunction = (data) => {}

  useEffect(() => {
    //console.log(payments)
  }, [payments])

  return (
    <div className="w-100 d-flex">
      <div className="container d-flex flex-column">
        <div className="w-100 mt-5">
          <button onClick={() => navigate(-1)} className="back-button">
            &#60; Volver
          </button>
        </div>
        <h1 className="my-5">Pagos - Inmueble {currentData.code}</h1>
        <div className="d-flex justify-content-end">
          <Link
            to={`${currentLink}/${id}/nuevo-pago`}
            className="primary-button"
          >
            Registrar pago
          </Link>
        </div>
        <TableComponent
          id={"property-payments-table"}
          headers={propertyPaymentsTableHeaders}
          body={propertyPaymentsTableBody}
          skip={0}
          data={payments}
          link={``}
          hasOwnLink={true}
          needOptions={true}
          deleteAction={handleOnClick}
        />
      </div>
    </div>
  )
}

export default PropertyPaymentsList
